import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

//HTTP
import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from "@angular/common/http";

import { IonicStorageModule } from '@ionic/storage';


//Provider
import { ServiceSidemenuProvider } from '../providers/service-sidemenu/service-sidemenu';
import { ServiceApiProvider } from '../providers/service-api/service-api';
import { ServiceGvariableProvider } from '../providers/service-gvariable/service-gvariable';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import { PrintProvider } from '../providers/print/print';
import { Network } from '@ionic-native/network';
import { NetworkProvider } from '../providers/service-network/network';

//Component
import { ComponentHeaderPage } from '../pages/component-header/component-header';

//Page
import { A01LoginPage } from '../pages/a01-login/a01-login';
import { B01SalesPage } from '../pages/b01-sales/b01-sales';
import { B02RefundPage } from '../pages/b02-refund/b02-refund';
import { B02D02RefundListPage } from '../pages/b02-d02-refund-list/b02-d02-refund-list';
import { B03ReportPage } from '../pages/b03-report/b03-report';
import { B04LaybyPage } from '../pages/b04-layby/b04-layby';
import { B04D02LaybyListPage } from '../pages/b04-d02-layby-list/b04-d02-layby-list';
import { B05ProfilePage } from '../pages/b05-profile/b05-profile';
import { B06SettingPage } from '../pages/b06-setting/b06-setting';
import { B07LogoutPage } from '../pages/b07-logout/b07-logout';
import { B03D02ReportFullPage } from '../pages/b03-d02-report-full/b03-d02-report-full';
import { B01D02SalesPaymentPage } from '../pages/b01-d02-sales-payment/b01-d02-sales-payment';
import { B06aProfileInfoPage } from '../pages/b06a-profile-info/b06a-profile-info';
import { PrinterListModalPage } from '../pages/printer-list-modal/printer-list-modal';
import { B08PrinterPage } from '../pages/b08-printer/b08-printer';
import { B09InventoryPage } from '../pages/b09-inventory/b09-inventory';



@NgModule({
  declarations: [
    MyApp,
    A01LoginPage,
    B01SalesPage,
    B01D02SalesPaymentPage,
    B02RefundPage,
    B02D02RefundListPage,
    B03ReportPage,
    B03D02ReportFullPage,
    B04LaybyPage,
    B04D02LaybyListPage,
    B05ProfilePage,
    B06SettingPage,
    B06aProfileInfoPage,
    B07LogoutPage,
    B08PrinterPage,
    B09InventoryPage,
    ComponentHeaderPage,
    PrinterListModalPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {}, {
      links: [
       { component: A01LoginPage, name: 'Login', segment: 'login' },
       { component: B01SalesPage, name: 'Sales', segment: 'sales' },
       { component: B01D02SalesPaymentPage, name: 'SalesPayment', segment: 'salespayment' },
       { component: B02RefundPage, name: 'Refund', segment: 'refund' },
       { component: B02D02RefundListPage, name: 'RefundList', segment: 'refundlist' },
       { component: B03ReportPage, name: 'Report', segment: 'report' },
       { component: B04LaybyPage, name: 'Layby', segment: 'layby' },
       { component: B04D02LaybyListPage, name: 'Laybylist', segment: 'laybylist' },
       { component: B05ProfilePage, name: 'Profile', segment: 'profile' },
       { component: B06SettingPage, name: 'Setting', segment: 'setting' },
       { component: B06aProfileInfoPage, name: 'Setting', segment: 'setting' },
       { component: B07LogoutPage, name: 'Logout', segment: 'logout' },
       { component: B08PrinterPage, name: 'Printer', segment: 'printer' },
       { component: B09InventoryPage, name: 'Inventory', segment: 'inventory' },
       { component: PrinterListModalPage, name: 'PrinterList', segment: 'printerlist' },
     ]
   }),
   HttpModule,
   HttpClientModule,
   IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    A01LoginPage,
    B01SalesPage,
    B01D02SalesPaymentPage,
    B02RefundPage,
    B02D02RefundListPage,
    B03ReportPage,
    B03D02ReportFullPage,
    B04LaybyPage,
    B04D02LaybyListPage,
    B05ProfilePage,
    B06SettingPage,
    B06aProfileInfoPage,
    B07LogoutPage,
    B08PrinterPage,
    B09InventoryPage,
    ComponentHeaderPage,
    PrinterListModalPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ServiceSidemenuProvider,
    ServiceApiProvider,
    ServiceGvariableProvider,
    ScreenOrientation,
    BarcodeScanner,
    BluetoothSerial,
    PrintProvider,
    Storage,
    Network,
    NetworkProvider,

  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts